import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutGrid, LogOut, Shirt, Coins, Plus, ShieldCheck } from "lucide-react";

export const Header = () => {
  const { user, login, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <header
      className="h-16 border-b border-border flex items-center justify-between px-4 sm:px-6 bg-white/80 backdrop-blur-xl sticky top-0 z-50"
      data-testid="app-header"
    >
      <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-home-link">
        <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center rounded-sm transition-transform group-hover:-rotate-6">
          <Shirt className="w-4 h-4 text-white" strokeWidth={2.2} />
        </div>
        <span className="font-display text-lg tracking-tight font-semibold hidden sm:block">MOCKUP STUDIO</span>
      </Link>

      <div className="flex items-center gap-2 sm:gap-3">
        {user && (
          <button
            onClick={() => navigate("/credits")}
            data-testid="credit-badge"
            className="flex items-center gap-2 h-9 pl-3 pr-2 rounded-sm border border-border bg-white hover:border-[#002FA7] transition-colors group"
          >
            <Coins className="w-4 h-4 text-[#CA8A04]" />
            <span className="text-sm font-semibold tabular-nums" data-testid="credit-balance">{user.credits ?? 0}</span>
            <span className="w-5 h-5 rounded-sm bg-[#002FA7] text-white flex items-center justify-center group-hover:scale-110 transition-transform">
              <Plus className="w-3 h-3" />
            </span>
          </button>
        )}
        {user?.is_admin && (
          <Link to="/admin" data-testid="nav-admin-link">
            <Button
              variant={location.pathname === "/admin" ? "default" : "ghost"}
              className="rounded-sm gap-2 text-xs uppercase tracking-[0.15em]"
              size="sm"
            >
              <ShieldCheck className="w-4 h-4" /> <span className="hidden sm:inline">Admin</span>
            </Button>
          </Link>
        )}
        {user && (
          <Link to="/dashboard" data-testid="nav-dashboard-link">
            <Button
              variant={location.pathname === "/dashboard" ? "default" : "ghost"}
              className="rounded-sm gap-2 text-xs uppercase tracking-[0.15em]"
              size="sm"
            >
              <LayoutGrid className="w-4 h-4" /> <span className="hidden sm:inline">Mis mockups</span>
            </Button>
          </Link>
        )}
        {user ? (
          <div className="flex items-center gap-2">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-8 h-8 rounded-full border border-border" data-testid="user-avatar" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-neutral-200 flex items-center justify-center text-xs font-medium">
                {(user.name || user.email || "?").charAt(0).toUpperCase()}
              </div>
            )}
            <Button variant="ghost" size="icon" onClick={logout} className="rounded-sm" data-testid="logout-btn">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        ) : (
          <Button onClick={() => navigate("/login")} className="rounded-sm bg-[#002FA7] hover:bg-[#00248a] text-white gap-2 text-xs uppercase tracking-[0.15em]" data-testid="login-btn">
            Entrar
          </Button>
        )}
      </div>
    </header>
  );
};
